import React from 'react';
import {
    Box,
    Divider,
    Stack,
    Typography,

} from '@mui/material';

import { AutoAwesome } from '@mui/icons-material';
import config from 'config';

const new_items: string[] = [
    'Multiple banner links and ui improvments',
    'Metrics based gross improvments',
    'Monitor reports filtering',
    'Impressions validation in media serve channels',
    'User mobile with country prefix',
    'Dynamic formulas (testing)',
    '3rd party  auth (testing)',
    'Send report to clint with OTP (testing)',
    'Media plan approval (testing)',
    'UI improvements',
    'General bug fixes'];


const VersionDetails = () => (<div style={{'direction':'ltr'}}>
                <Stack spacing={2} sx={{ mt: 1 }}>
    {/* New */}
    {new_items.length > 0 &&<Box>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
            <AutoAwesome color="success" fontSize="small" />
            <Typography variant="subtitle1" fontWeight={700} sx={{px:1}}>
                {`September 2026 V.${config.version_num}`}
            </Typography>
        </Stack>

        <Stack spacing={0.75}>
            {new_items.map((i)=> <Typography variant="body2" color="text.secondary">❯ {i}</Typography>)}
        </Stack>
    </Box>}

</Stack>
            </div>)

export default VersionDetails;